export class LoginModel{
    mobileNumber:string;
	userPassword:string;
}